{
    "PageTitle": "Prenotazione di sale riunioni / postazioni temporanee",
    "location": "Seleziona posizione / stanza",
    "date": "Data",
    "from_date": "Dalla data",
    "to_date": "Alla data",
    "toDateError": "La 'Alla data' deve essere uguale o successiva alla 'Dalla data' e il divario massimo tra le due date è di 30 giorni.",
    "topic": "Argomento",
    "timeFrom": "Ora di inizio",
    "timeUntil": "Ora di fine",
    "startTime": "Ora di inizio",
    "capacity": "Quante persone parteciperanno?",
    "btnSubmit": "Invia",
    "btnReset": "Reimposta",
    "formReset": "Reimposta modulo",
    "errMsg": "Si prega di compilare tutti i campi!",
    "inputPlaceholder": "input...",
    "hours": "ore",
    "minutes": "minuti",
    "starting": "Inizio",
    "duration": "Durata",
    "btnSearch": "Cerca",
    "locationOptionLabel": "Posizione, Nome stanza / Numero",
    "startOptionLabel": "Seleziona ora di inizio",
    "durationOptionLabel": "Seleziona durata",
    "capacityOptionLabel": "Seleziona capacità",
    "searchText": "attendere, stiamo cercando di connetterci al server!",
    "dummyLocationValueOne": "Posizione 1",
    "dummyLocationValueTwo": "Posizione 2",
    "roomAvailableTextDummy": "Trovati 27 spazi per il 24 aprile, 13:00 - 14:00 in Hallstadter Straße 119 - Schulungsgebäude",
    "roomAvailableFound": "Trovati",
    "roomAvailableSpaces": "spazi a",
    "roomAvailablein": "in",
    "floorDropdownDummy": " EG Schulungsgebäude",
    "selectedFloorOptionOneDummy": "EG",
    "selectedFloorOptionTwoDummy": "OG",
    "meetingLocationLabel": "Luogo della riunione",
    "titleOfMeetingLabel": "Titolo della riunione",
    "titleOfMeetingPlaceholder": "Inserisci il titolo o l'argomento della riunione pianificata",
    "descOfMeetingPlaceholder": "Aggiungi descrizione",
    "meetingDescriptionLabel": "Descrizione della riunione (opzionale)",
    "availableLabel": "Disponibile",
    "busyLabel": "Occupato",
    "confirmBookingBtn": "Conferma prenotazione",
    "bookingSuccessLabel": "Prenotazione della stanza avvenuta con successo",
    "bookingFailureLabel": "Qualcosa è andato storto. Si prega di riprovare più tardi.",
    "selectRoomLocation": "Seleziona posizione / stanza",
    "futureDateError": "Si prega di selezionare una data/ora futura corretta.",
    "noSlotAvailable": "Nessuna fascia disponibile",
    "tokenRequired": "Token di accesso richiesto mancante o scaduto.",
    "roomBooked": "La stanza è già prenotata!",
    "roomPartiallyBooked": "La stanza è parzialmente prenotata!",
    "participantError": "Hai intenzione di prenotare per ",
    "participantErrorMsg": " partecipanti, tuttavia la capacità della stanza è solo ",
    "partiallyFree": "Parzialmente libero",
    "startingTime": "Ora di inizio",
    "participants": "N. di partecipanti",
    "max": "Max",
    "capacityLabel": "Capacità ",
    "dashboard": "Mostra le mie prenotazioni",
    "manageBookings": "Gestisci prenotazioni",
    "bookAgain": "Prenota di nuovo",
    "cancelBookingConfrim": "Sei sicuro di voler annullare questa riunione?",
    "list": "Elenco",
    "search": "Cerca",
    "type": "Tipo",
    "updateBookingApiSucessMsg": "Prenotazione aggiornata con successo",
    "rebookingApiSucessMsg": "Prenotato con successo",
    "cancelBookingApiSucessMsg": "Prenotazione annullata con successo",
    "noUpcomingBooking": "Attualmente non hai prenotazioni imminenti",
    "noPastBooking": "Attualmente non hai prenotazioni passate",
    "apiFailDefaultMsg": "Qualcosa è andato storto. Si prega di riprovare più tardi.",
    "confirm": "Conferma",
    "cancel": "Annulla",
    "close": "Chiudi",
    "fieldRequired": "Questo campo è obbligatorio",
    "selectLocation": "Si prega di selezionare la posizione",
    "selectDate": "Si prega di selezionare una data per la prenotazione",
    "meetingTitleMissing": "Titolo della riunione mancante",
    "numberOfParticipantMissing": "Numero di partecipanti mancante",
    "gingcoDisclaimer": "MyHelp assiste in un'esperienza di prenotazione delle stanze facile. Per altri servizi Gingco (es: Servizi di Catering) puoi contattare Gingco.",
    "availability": {
        "text": "Disponibilità",
        "free": "Sì, disponibile",
        "busy": "Spiacente, non disponibile",
        "busyHint": "Prova a modificare la data o l'ora, puoi anche controllare le stanze vicine",
        "partialFree": "Stanza parzialmente libera",
        "unknown": "Sconosciuto"
    },
    "manageBooking": {
        "meetingLocation": "Luogo della riunione",
        "reschedule": "Ripianifica",
        "bookAgain": "Prenota di nuovo",
        "rescheduleTo": "Ripianifica a",
        "cancelMeeting": "Annulla riunione",
        "searchPlaceholder": "Cerca per ID riunione, Descrizione, Posizione"
    },
    "durationOptions": {
        "15 Min": "15 Min",
        "30 Min": "30 Min",
        "45 Min": "45 Min",
        "1 Hr": "1 Hr",
        "2 Hr": "2 Hr",
        "4 Hr": "4 Hr",
        "8 Hr": "8 Hr"
    },
    "meetingRoomTypes": {
        "All": "Tutti",
        "Hot Desk": "Hot Desk",
        "Meeting Room": "Sala riunioni"
    },
    "peopleCount": "Quante persone partecipano?"
}